import { AgentEntity } from '../entity/agent';
import { Entity } from '../model';

export class MyCallCenterStatus extends AgentEntity {
  public static object_type_id: string = 'my_cc_status';
}
